import { Button } from '@/shared/components';

/**
 * Sagt, was nicht geladen werden konnte, und bietet den erneuten Versuch an. Bei der Kanalliste
 * kommt der Text vom Server: nur er weiß, warum kontoweit kein Kanal veröffentlicht wurde.
 */
export function ChannelCloseoutLoadNotice({
  message,
  onRetry,
}: {
  message: string;
  onRetry: () => void;
}) {
  return (
    <div role="alert" className="space-y-3 px-6 py-4 text-sm">
      <p className="text-sealwax">{message}</p>
      <Button type="button" variant="ghost" onClick={onRetry}>
        Erneut versuchen
      </Button>
    </div>
  );
}
